import { gql, useQuery } from '@sortlist-frontend/data-fetching/public';
import type { GetWorkQuery } from '@sortlist-frontend/data-fetching/public-types';

import { acceptLanguageHeader } from '_core/api/api-nextjs-proxy';

export const WORK_QUERY = gql(`
  query GetWork($slug: String!) {
    work(slug: $slug) {
      id
      slug
      name
      description
      position
      startDate
      endDate
      illustrationUrls
      challenges
      solutions
      impacts
      link
      budget
      company {
        id
        name
        address
        marketType
        marketSize
        sector {
          id
          name
        }
      }
      agency {
        id
        name
        slug
        logoUrl
      }
      aspects(first: 5) {
        nodes {
          id
          expertise {
            id
            name
          }
        }
      }
    }
  }
`);

export type WorkDetail = NonNullable<GetWorkQuery['work']>;

export const useGetWork = ({
  workSlug,
  locale,
  enabled = true,
}: {
  workSlug: string;
  locale: string;
  enabled?: boolean;
}) => {
  return useQuery(WORK_QUERY, {
    variables: { slug: workSlug },
    context: {
      headers: {
        'Accept-Language': acceptLanguageHeader(locale),
      },
    },
    skip: !enabled || workSlug === '',
  });
};
